<template>
  <div class="crop-overlay">
    <div class="crop-card">
      <div class="crop-header">
        <h3 class="crop-header__title">Upload Photo</h3>
        <button aria-label="Close" class="crop-header__close" @click="close">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M13 5l-8 8M5 5l8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
          </svg>
        </button>
      </div>

      <div class="crop-stage">
        <input v-if="status" id="uploadFileInput" type="file" accept="image/png,image/jpeg" @change="upload" />
        <vueCropper
          v-else
          ref="cropper"
          :img="option.img"
          :output-size="option.size"
          :output-type="option.outputType"
          :info="true"
          :can-scale="option.canScale"
          :full="option.full"
          :can-move="option.canMove"
          :can-move-box="option.canMoveBox"
          :original="option.original"
          :auto-crop="option.autoCrop"
          :fixed="option.fixed"
          :fixed-number="option.fixedNumber"
          :center-box="option.centerBox"
          :info-true="option.infoTrue"
          :fixed-box="option.fixedBox"
          :mode="option.mode"
        />
        <div v-if="coverDom" class="crop-stage__loading">
          <div class="crop-spinner"></div>
        </div>
      </div>

      <div class="crop-info">
        <div class="crop-info__tip">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1" />
            <path d="M7 4v3.5M7 10h.006" stroke="currentColor" stroke-width="1" stroke-linecap="round" />
          </svg>
          <span>Face forward, centered, level, and without glasses</span>
        </div>
      </div>

      <div class="crop-actions">
        <button class="crop-actions__btn crop-actions__btn--secondary" @click="close">Cancel</button>
        <button class="crop-actions__btn crop-actions__btn--primary" :disabled="loading" @click="finish">
          <span v-if="!loading">Submit</span>
          <span v-else class="crop-actions__loading-text">Processing...</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
function getBoxInfo(w1, h1, w2, h2) {
  const scaleX = w1 / w2
  const scaleY = h1 / h2
  return {
    x: scaleX.toFixed(6),
    y: scaleY.toFixed(6)
  }
}
export default {
  name: 'cropperImg',
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      status: true,
      coverDom: false,
      option: {
        img: '',
        info: true,
        outputSize: 1,
        outputType: 'jpeg',
        canScale: false,
        autoCrop: true,
        fixedBox: false,
        fixed: true,
        fixedNumber: [this.config.width, this.config.height],
        autoCropWidth: '90%',
        autoCropHeight: '90%',
        full: true,
        canMoveBox: true,
        original: true,
        centerBox: true,
        infoTrue: false,
        mode: 'contain'
      }
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.uploadFile()
  },
  methods: {
    close() {
      this.$emit('close')
    },
    uploadFile() {
      try {
        document.querySelector('#uploadFileInput').click()
      } catch (e) {}
    },
    upload(e) {
      const file = e.target.files[0]
      if (!file.type.includes('image')) {
        this.$tips({ msg: 'Please select a file of picture type' })
        return false
      }
      const self = this
      this.createReader(file, function (w, h) {
        self.coverDom = true
        self.file2base64(file)
      })
    },
    createReader(file, whenReady) {
      const reader = new FileReader()
      reader.onload = function (evt) {
        const image = new Image()
        image.onload = function () {
          const width = this.width
          const height = this.height
          if (whenReady) {
            whenReady(width, height)
          }
        }
        image.src = evt.target.result
      }
      reader.readAsDataURL(file)
    },
    file2base64(file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      const self = this
      reader.onload = function (e) {
        const newUrl = this.result
        self.$nextTick(() => {
          self.option.img = newUrl
          self.status = false
          setTimeout(() => {
            const img = new Image()
            img.src = newUrl
            img.onload = function () {
              self.$nextTick(() => {
                self.$refs.cropper.scale = getBoxInfo(self.config.width * 0.9, self.config.height * 0.9, img.naturalWidth, img.naturalHeight).x
                self.coverDom = false
              })
            }
          }, 1200)
        })
      }
    },
    finish() {
      if (!this.$refs.cropper) {
        this.uploadFile()
        return false
      }
      this.$refs.cropper.getCropBlob(data => {
        const file = new File([data], 'proFileCover.jpg', { type: data.type, lastModified: Date.now() })
        const params = new FormData()
        params.append('file', file)
        this.$emit('file', params)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$primary: #3067f2;
$primary-dim: rgba(48, 103, 242, 0.1);
$text: #1a1a1a;
$text-soft: #6b6b6b;
$white: #fff;
$cream: #fafaf8;
$border: #e8e5e0;
$border-strong: #d4cfc7;
$shadow-card: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
$radius: 14px;
$radius-sm: 10px;
$ease-out: 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);

.crop-overlay {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(18, 18, 20, 0.4);
  backdrop-filter: blur(8px);
  animation: overlayIn 0.25s ease-out;
}

@keyframes overlayIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.crop-card {
  width: 480px;
  max-width: 100%;
  max-height: 90vh;
  background: $white;
  border-radius: $radius;
  box-shadow: $shadow-card;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: cardIn 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

@keyframes cardIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.crop-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid $border;
  flex-shrink: 0;

  &__title {
    font-size: 15px;
    font-weight: 500;
    color: $text;
    margin: 0;
    letter-spacing: 0.02em;
  }

  &__close {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    background: transparent;
    color: $text-soft;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all $ease-out;

    &:hover {
      background: rgba(0, 0, 0, 0.04);
      color: $text;
    }
  }
}

.crop-stage {
  position: relative;
  width: 100%;
  height: 360px;
  background: #f2f0ed;
  flex-shrink: 0;
  overflow: hidden;

  ::v-deep .vue-cropper {
    background-image: none;
    background-color: #f2f0ed;
  }

  &__loading {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(3px);
    z-index: 3;
  }
}

.crop-spinner {
  width: 32px;
  height: 32px;
  border: 2.5px solid $primary-dim;
  border-top-color: $primary;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.crop-info {
  padding: 12px 20px;
  flex-shrink: 0;

  &__tip {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 13px;
    color: $text-soft;
    line-height: 1.5;

    svg {
      flex-shrink: 0;
      margin-top: 1px;
      color: $primary;
    }
  }
}

.crop-actions {
  display: flex;
  gap: 10px;
  padding: 0 20px 18px;
  flex-shrink: 0;

  &__btn {
    flex: 1;
    padding: 11px 16px;
    font-size: 14px;
    font-weight: 500;
    border-radius: $radius-sm;
    cursor: pointer;
    transition: all $ease-out;
    font-family: inherit;
    letter-spacing: 0.02em;
    border: none;

    &:active {
      transform: scale(0.98);
    }

    &--secondary {
      background: $white;
      color: $text;
      border: 1px solid $border-strong;

      &:hover {
        background: $cream;
      }
    }

    &--primary {
      background: $primary;
      color: $white;

      &:hover {
        background: darken($primary, 5%);
      }

      &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
      }
    }
  }

  &__loading-text {
    display: inline-flex;
    align-items: center;
    gap: 8px;

    &::before {
      content: '';
      width: 14px;
      height: 14px;
      border: 2px solid rgba(255, 255, 255, 0.3);
      border-top-color: $white;
      border-radius: 50%;
      animation: spin 0.6s linear infinite;
    }
  }
}

#uploadFileInput {
  position: absolute;
  z-index: -100;
  opacity: 0;
}

@media screen and (max-width: 768px) {
  .crop-overlay {
    padding: 0;
    align-items: flex-end;
  }

  .crop-card {
    width: 100%;
    max-height: 85vh;
    border-radius: $radius $radius 0 0;
    animation: cardUp 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  @keyframes cardUp {
    from {
      transform: translateY(40px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .crop-stage {
    height: 300px;
  }

  .crop-header {
    padding: 12px 16px;

    &__title {
      font-size: 14px;
    }
  }

  .crop-info {
    padding: 10px 16px;

    &__tip {
      font-size: 12px;
    }
  }

  .crop-actions {
    padding: 0 16px 16px;
    gap: 8px;

    &__btn {
      font-size: 13px;
      padding: 10px 14px;
    }
  }
}

@media screen and (max-width: 420px) {
  .crop-card {
    max-height: 80vh;
  }

  .crop-stage {
    height: 250px;
  }

  .crop-header {
    padding: 10px 14px;

    &__title {
      font-size: 13px;
    }
  }

  .crop-info {
    padding: 8px 14px;

    &__tip {
      font-size: 11px;
    }
  }

  .crop-actions {
    padding: 0 14px 14px;

    &__btn {
      font-size: 12px;
      padding: 9px 12px;
    }
  }
}
</style>
